import { useQuery } from "react-query";

const fetchArticle = async ({ articleId }) => {
  const response = await fetch(
    `${process.env.REACT_APP_API}/intercom/article/${articleId}`
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch article");
  }

  return data;
};

const fetchCollection = async ({ collectionId }) => {
  const response = await fetch(
    `${process.env.REACT_APP_API}/intercom/collection/${collectionId}`
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch collection");
  }

  return data;
};

const fetchCollections = async () => {
  const response = await fetch(
    `${process.env.REACT_APP_API}/intercom/collections`
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch collections");
  }

  return data;
};

const searchArticles = async ({ searchTerm }) => {
  if (!searchTerm || searchTerm.trim().length === 0) {
    return { data: { articles: [] }, total_count: 0 };
  }

  const response = await fetch(
    `${process.env.REACT_APP_API}/intercom/search/${encodeURIComponent(searchTerm.trim())}`
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to search articles");
  }

  return data;
};

export const useArticle = (articleId) => {
  return useQuery({
    queryKey: ["article", articleId],
    queryFn: () => fetchArticle({ articleId }),
    enabled: !!articleId,
  });
};

export const useCollection = (collectionId) => {
  return useQuery({
    queryKey: ["collection", collectionId],
    queryFn: () => fetchCollection({ collectionId }),
    enabled: !!collectionId,
  });
};

export const useCollections = () => {
  return useQuery({
    queryKey: ["collections"],
    queryFn: fetchCollections,
  });
};

export const useSearchArticles = (searchTerm) => {
  return useQuery({
    queryKey: ["searchArticles", searchTerm],
    queryFn: () => searchArticles({ searchTerm }),
    enabled: !!searchTerm && searchTerm.trim().length > 0,
    staleTime: 30000, // Cache for 30 seconds
  });
};
